import * as Dates from "./date";
import * as UI from "./ui";

export { Dates, UI };

export const FIREFOX = "firefox";